import { createSingleEntityStore } from '@recruitee/ngrx';

import type { RequisitionsFilterCounters } from './filter-counters.types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<RequisitionsFilterCounters>()('RequisitionsFilterCounters');

export {
  selectors as RequisitionsFilterCountersSelectors,
  actions as RequisitionsFilterCountersActions,
  reducer as RequisitionsFilterCountersReducer,
  namespace as RequisitionsFilterCountersNamespace,
};
